import { useNavigate } from 'react-router-dom'
import { Gamepad2, Home } from 'lucide-react'

const GameNotFound = () => {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <div className="flex h-screen items-center justify-center bg-linear-to-br from-orange-950  to-gray-950">
      <div className="px-4 text-center">
        <div className="relative mb-8">
          <h1 className="text-9xl font-bold text-orange-500 opacity-20">404</h1>
          <Gamepad2 className="absolute left-1/2 top-1/2 size-32 -translate-x-1/2 -translate-y-1/2 text-orange-500" />
        </div>
        <h2 className="my-4 text-4xl font-semibold text-white">
          Game Not Found !
        </h2>
        <p className="mb-8 text-xl text-orange-200">
          You&apos;ve Entered the Wrong Page!.
        </p>
        <div className="space-y-4">
          <p className="text-lg text-orange-100">
            We searched high and low but couldn’t find what you’re looking for.
            <br /> Let’s find a better place for you to go.
          </p>
          <button
            onClick={handleGoHome}
            className="inline-flex items-center rounded-2xl bg-button-gradient px-6 py-3 text-lg font-medium text-white transition-colors duration-200 hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          >
            <Home className="mr-2 size-5" />
            Return to Home Base
          </button>
        </div>
      </div>
    </div>
  )
}

export default GameNotFound
